import StartEvaluationPage from './StartEvaluationPage'

export default StartEvaluationPage
